import script from "./SpeciesLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeciesLink.vue?vue&type=script&setup=true&lang=js"

import "./SpeciesLink.vue?vue&type=style&index=0&id=11a0f5b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a0f5b3"]])

export default __exports__